<template lang="html">
  <Form><slot></slot></Form>
</template>
<script>
  import Form from './_form.vue'
  export default {
    components: {
      Form,
    }
  }
</script>
<style lang="scss">
</style>